import { Injectable } from '@angular/core';

import DomainEventProvider from '../../core/domain/events/domain_event_provider';
import { IncomingMessageEvent } from './incoming-message-event';

@Injectable({ providedIn: 'root' })
export class IncomingMessageEventProvider extends DomainEventProvider<IncomingMessageEvent> {}
